var _path, _path2, _path3, _mask, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaticChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 15.9002C13.8598 15.9002 14.8 14.96 14.8 13.8002C14.8 12.6404 13.8598 11.7002 12.7 11.7002C11.5402 11.7002 10.6 12.6404 10.6 13.8002C10.6 14.96 11.5402 15.9002 12.7 15.9002Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6047 15.8999C21.7645 15.8999 22.7047 14.9597 22.7047 13.7999C22.7047 12.6402 21.7645 11.7 20.6047 11.7C19.4449 11.7 18.5047 12.6402 18.5047 13.7999C18.5047 14.9597 19.4449 15.8999 20.6047 15.8999Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5092 15.8999C29.669 15.8999 30.6092 14.9597 30.6092 13.7999C30.6092 12.6402 29.669 11.7 28.5092 11.7C27.3494 11.7 26.4092 12.6402 26.4092 13.7999C26.4092 14.9597 27.3494 15.8999 28.5092 15.8999Z",
    fill: "current"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_712_1716",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2647 0C5.93881 0 0 5.93881 0 13.2647V14.4706C0 21.7965 5.93881 27.7353 13.2647 27.7353H24.4053L24.4335 34.9794L34.7379 25.7384C38.4976 23.3969 41 19.226 41 14.4706V13.2647C41 5.93881 35.0612 0 27.7353 0H13.2647Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4053 27.7353L27.2053 27.7244L27.1945 24.9353H24.4053V27.7353ZM24.4335 34.9794L21.6336 34.9903L21.6578 41.2297L26.3029 37.0639L24.4335 34.9794ZM34.7379 25.7384L33.2577 23.3617L33.0503 23.4908L32.8685 23.6539L34.7379 25.7384ZM2.8 13.2647C2.8 7.48521 7.48521 2.8 13.2647 2.8V-2.8C4.39242 -2.8 -2.8 4.39241 -2.8 13.2647H2.8ZM2.8 14.4706V13.2647H-2.8V14.4706H2.8ZM13.2647 24.9353C7.48521 24.9353 2.8 20.2501 2.8 14.4706H-2.8C-2.8 23.3429 4.39242 30.5353 13.2647 30.5353V24.9353ZM24.4053 24.9353H13.2647V30.5353H24.4053V24.9353ZM27.2335 34.9685L27.2053 27.7244L21.6054 27.7462L21.6336 34.9903L27.2335 34.9685ZM32.8685 23.6539L22.5641 32.8949L26.3029 37.0639L36.6073 27.823L32.8685 23.6539ZM38.2 14.4706C38.2 18.219 36.2311 21.5099 33.2577 23.3617L36.2181 28.1152C40.7642 25.2839 43.8 20.2329 43.8 14.4706H38.2ZM38.2 13.2647V14.4706H43.8V13.2647H38.2ZM27.7353 2.8C33.5148 2.8 38.2 7.48521 38.2 13.2647H43.8C43.8 4.39241 36.6076 -2.8 27.7353 -2.8V2.8ZM13.2647 2.8H27.7353V-2.8H13.2647V2.8Z",
    fill: "current",
    mask: "url(#path-4-inside-1_712_1716)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticChat);
export default __webpack_public_path__ + "static/media/static-chat.35415e56369928e1e7c83010986c4c91.svg";
export { ForwardRef as ReactComponent };